import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient} from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import {IDataToSendForChangePassword} from './pre-login.model';

@Injectable({
  providedIn: 'root'
})
export class ChangePasswordService {

  rootScopeData: RootScopeDeclare;

  constructor(private httpClient: HttpClient, private rootScopeService: RootScopeService, private httpHeaderService: HttpHeadersService) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  changeToNewPassword(data: IDataToSendForChangePassword): Observable<any> {
   const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
   return this.httpClient.post(environment.servicePath + '/lfuser/changepassword', data, { headers});

  }
}
